import { axiosService } from 'services';
import { AXIOS_URLS } from 'config';
import { ServiceStation } from 'interfaces';

export const stationsService = {
  getUserStations: (): Promise<ServiceStation[]> =>
    axiosService.get(AXIOS_URLS.service_stations).then((res) => res.data),
};
